<script>
    import Axios from 'axios'
    import AOS from 'aos'
    import api from './api'
    import _ from 'lodash'
    import 'aos/dist/aos.css'



    import  onepageViewNoAuth  from './layouts/onepageViewNoAuth.vue';

    import  leanView  from './layouts/leanView.vue';
    import  onepageView  from './layouts/onepageView.vue';
    import  sidebarView  from './layouts/sidebarView.vue';

    import { mapGetters, mapActions } from 'vuex'

    const default_layout = "onepageView";

/*     var console = {};
    console.log = function(){};
    window.console = console; */

    export default {
        name: 'app',
        data(){
            return {}
        },
        components: {
            onepageView,
            sidebarView,
            onepageViewNoAuth,
            leanView
            },
        computed: {
        ...mapGetters('loading', ['loadingAppReRender']),            
            layout(){
                return ((this.$route.matched.some(m => m.meta.layout)) ? this.$route.matched.find(m => m.meta.layout).meta.layout  : false || default_layout);
            }
        },
        created(){
        
        }
    }
    
</script>
<template>
<div style="height:100%;">
    <component :is="layout" :key="loadingAppReRender">
        <router-view />
    </component>
</div>
</template>
<style>

</style>



// WEBPACK FOOTER //
// src/App.vue